/* eslint-disable max-len */
var ICON_LOGO_YOUTUBE = {
  "default": 'M23.25 7.44C23.25 6.52766 22.8876 5.65268 22.2424 5.00755C21.5973 4.36243 20.7223 4 19.81 4H4.19C3.73825 4 3.29093 4.08898 2.87357 4.26185C2.45621 4.43473 2.07699 4.68812 1.75755 5.00755C1.11243 5.65268 0.75 6.52766 0.75 7.44V16.56C0.75 17.4723 1.11243 18.3473 1.75755 18.9924C2.07699 19.3119 2.45621 19.5653 2.87357 19.7381C3.29093 19.911 3.73825 20 4.19 20H19.81C20.7223 20 21.5973 19.6376 22.2424 18.9924C22.8876 18.3473 23.25 17.4723 23.25 16.56V7.44ZM9.5 15.94V7.28L16.27 11.61L9.5 15.94Z',
  v2: true
};

export { ICON_LOGO_YOUTUBE };
//# sourceMappingURL=ICON_LOGO_YOUTUBE.js.map
